import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Star } from 'lucide-react';

const testimonials = [
  {
    quote: "My experience with Utopian Creations has exceeded my expectations. Our website is beautiful, intuitive and received an overwhelming response from day one. It's a snap! They are so easy and kind to work with! I'm giving 5 stars and more to this team.",
    name: "Moffatt Ranch",
    role: "Family Farm, Brentwood CA",
    rating: 5,
  },
  {
    quote: "Josh is an exceptionally talented and dedicated website designer. He transformed my mother's jewelry business website into a polished, professional, and visually stunning platform that truly captures her brand's essence. Beyond the aesthetics, he built an intuitive and user-friendly back end that makes site management effortless. His work exceeded all expectations.",
    name: "May",
    role: "Ravenscroft Design",
    rating: 5,
  },
];

const Testimonials = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.section
      ref={ref}
      id="testimonials"
      className="py-24"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="brand-header font-sans text-4xl font-extrabold sm:text-5xl mb-4">
            What my clients say
          </h2>
          <p className="text-lg text.body max-w-2xl mx-auto">
            Real feedback from real clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md border border-gray-200 flex flex-col"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 20 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <blockquote className="text.body leading-relaxed mb-6 flex-grow">
                "{testimonial.quote}"
              </blockquote>
              <div>
                <p className="font-semibold text.heading">{testimonial.name}</p>
                <p className="text-sm text.muted">{testimonial.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Testimonials;
